export const messages={
    scheduler:"BOS Scheduler",
    newScheduler:" New Schedule"
}